<aside class="widget-area" id="secondary">
    <section class="widget widget_karlson_posts_thumb" style="
            background-size: 100px;
            padding: 20px;
            padding-top: 0;
            border: 1px solid #eeeeee;
        ">
        <div class="page-title-content" style="margin-top: 0; text-align: left">
            <ul>
                <li>
                    <a routerLink="/">
                        <i class="fa-solid fa-house"></i>
                    </a>
                </li>
                <li *ngIf="cuurent_menu_parent_name">
                    <span class="mx-1"></span>
                    {{ cuurent_menu_parent_name.DisplayNameBangla || cuurent_menu_parent_name.DisplayName }}
                </li>
                <li *ngIf="!cuurent_menu_parent_name">{{ current_main_route }}</li>
            </ul>
        </div>
    </section>


    <section class="widget widget_categories" style="
            background-size: 100px;
            padding: 20px;
            border: 1px solid #eeeeee;
            margin-top: 15px;
        ">
        <h3 class="widget-title">Related Topics</h3>

        <ul>
            <li *ngFor="let item of allSubmenuItems">
                <a [routerLink]="item.MenuUrl">{{ item.MenuName }}</a>
            </li>
        </ul>
    </section>
</aside>